/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Jade_Pike_TrotInputs */

const en_lean_jade_pike_trot = /** @type {(inputs: Lean_Jade_Pike_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A good description improves AI classification quality.`)
};

const de_lean_jade_pike_trot = /** @type {(inputs: Lean_Jade_Pike_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine gute Beschreibung verbessert die Qualität der KI-Klassifizierung.`)
};

/**
* | output |
* | --- |
* | "A good description improves AI classification quality." |
*
* @param {Lean_Jade_Pike_TrotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_jade_pike_trot = /** @type {((inputs?: Lean_Jade_Pike_TrotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Jade_Pike_TrotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_jade_pike_trot(inputs)
	return de_lean_jade_pike_trot(inputs)
});